import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'xos-images-carousel',
  imports: [],
  templateUrl: './images-carousel.component.html',
  styleUrls: ['./images-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class ImagesCarouselComponent implements AfterViewInit {
  @Input() images: string[] = [];
  @ViewChild('carouselTrack') carouselTrack!: ElementRef;

  constructor(private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.initCarousel();
  }

  initCarousel() {
    const track = this.carouselTrack.nativeElement;
    const totalWidth = track.scrollWidth;
    track.style.animationDuration = `${totalWidth / 100}px`; // Adjust speed based on content width
    const ua = navigator.userAgent;
    if (!track) return;
    if (/Chrome|Chromium|Edg\//.test(ua)) {
      this.renderer.addClass(track, 'is-chrome');
    } else {
      this.renderer.addClass(track, 'is-other');
    }
  }

  openInstagram() {
    window.open('https://www.instagram.com/xrossoversports?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==', '_blank');
  }
}
